import React from 'react';
import { MagnifyingGlass, FunnelSimple, X } from '@phosphor-icons/react';
import './PayrollFilters.css';

function PayrollFilters({ filters, onFiltersChange, onClearFilters, loading }) {
  const handleSearchChange = (e) => {
    onFiltersChange({ ...filters, search: e.target.value });
  };

  const handleStatusChange = (e) => {
    onFiltersChange({ ...filters, status: e.target.value });
  };

  const handlePeriodChange = (e) => {
    onFiltersChange({ ...filters, period: e.target.value });
  };

  const handleSalaryRangeChange = (e) => {
    onFiltersChange({ ...filters, salaryRange: e.target.value });
  };

  const hasActiveFilters = filters.search || filters.status || filters.period || filters.salaryRange;

  return (
    <div className="payroll-filters">
      <div className="filters-header">
        <div className="filter-icon">
          <FunnelSimple size={18} weight="bold" />
        </div>
        <h3>Filters & Search</h3>
      </div>

      <div className="filters-content">
        {/* Search */}
        <div className="filter-group">
          <label htmlFor="search">Search by Name or ID</label>
          <div className="search-wrapper">
            <MagnifyingGlass size={18} className="search-icon" />
            <input
              id="search"
              type="text"
              placeholder="Staff name or ID..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              disabled={loading}
              className="search-input"
            />
            {filters.search && (
              <button
                className="clear-search"
                onClick={() => handleSearchChange({ target: { value: '' } })}
                disabled={loading}
              >
                <X size={16} />
              </button>
            )}
          </div>
        </div>

        {/* Status Filter */}
        <div className="filter-group">
          <label htmlFor="status">Status</label>
          <select
            id="status"
            value={filters.status || ''}
            onChange={handleStatusChange}
            disabled={loading}
            className="filter-select"
          >
            <option value="">All Statuses</option>
            <option value="active">Active</option>
            <option value="draft">Draft</option>
            <option value="expired">Expired</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Period Filter */}
        <div className="filter-group">
          <label htmlFor="period">Period</label>
          <select
            id="period"
            value={filters.period || ''}
            onChange={handlePeriodChange}
            disabled={loading}
            className="filter-select"
          >
            <option value="">All Periods</option>
            <option value="current-month">Current Month</option>
            <option value="last-3-months">Last 3 Months</option>
            <option value="last-6-months">Last 6 Months</option>
            <option value="year-to-date">Year to Date</option>
          </select>
        </div>

        {/* Salary Range Filter */}
        <div className="filter-group">
          <label htmlFor="salary">Salary Range</label>
          <select
            id="salary"
            value={filters.salaryRange || ''}
            onChange={handleSalaryRangeChange}
            disabled={loading}
            className="filter-select"
          >
            <option value="">All Ranges</option>
            <option value="0-2000">GHS 0 - 2,000</option>
            <option value="2000-5000">GHS 2,000 - 5,000</option>
            <option value="5000-10000">GHS 5,000 - 10,000</option>
            <option value="10000+">GHS 10,000+</option>
          </select>
        </div>

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <button
            className="btn btn-secondary btn-sm"
            onClick={onClearFilters}
            disabled={loading}
          >
            <X size={16} /> Clear Filters
          </button>
        )}
      </div>

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="active-filters">
          {filters.search && (
            <span className="filter-tag">
              Search: {filters.search}
              <button
                onClick={() => handleSearchChange({ target: { value: '' } })}
                className="tag-close"
              >
                ×
              </button>
            </span>
          )}
          {filters.status && (
            <span className="filter-tag">
              Status: {filters.status}
              <button
                onClick={() => handleStatusChange({ target: { value: '' } })}
                className="tag-close"
              >
                ×
              </button>
            </span>
          )}
          {filters.period && (
            <span className="filter-tag">
              Period: {filters.period}
              <button
                onClick={() => handlePeriodChange({ target: { value: '' } })}
                className="tag-close"
              >
                ×
              </button>
            </span>
          )}
          {filters.salaryRange && (
            <span className="filter-tag">
              Salary: {filters.salaryRange}
              <button
                onClick={() => handleSalaryRangeChange({ target: { value: '' } })}
                className="tag-close"
              >
                ×
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default PayrollFilters;
